import React from 'react';
import Home from './Home';
import Services from './Services';
import Contact from './Contact';
import ScrollToHash from '../Components/ScrollToHash';
import './LandingPage.css';

/**
 * One-page: Inicio → Servicios → Ubícanos.
 */
export default function LandingPage() {
  return (
    <div className="landing_page home_page_bg">
      <ScrollToHash />
      <Home />
      <Services />
      <Contact />
    </div>
  );
}
